import { render, staticRenderFns } from "./ConfigAddEdit.vue?vue&type=template&id=24db070a"
import script from "./ConfigAddEdit.vue?vue&type=script&lang=js"
export * from "./ConfigAddEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports